/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var TechServerIcon24Solid = forwardRef('TechServerIcon24Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M2 5a3 3 0 0 1 3-3h14a3 3 0 0 1 3 3v2a3 3 0 0 1-3 3H5a3 3 0 0 1-3-3V5Zm5 1a1 1 0 1 1-2 0 1 1 0 0 1 2 0Z" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M5 11a3 3 0 0 0-3 3v2a3 3 0 0 0 3 3h6v3H5.25a1 1 0 1 0 0 2h13.5a1 1 0 1 0 0-2H13v-3h6a3 3 0 0 0 3-3v-2a3 3 0 0 0-3-3H5Zm1 5a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z" })));
});
